/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promos_Stock_Source_HintInputs */



/**
* | output |
* | --- |
* | "Whose stock these promos came from." |
*
* @param {Promos_Stock_Source_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_stock_source_hint = /** @type {((inputs?: Promos_Stock_Source_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_Stock_Source_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le stock de l'organisateur dont proviennent ces promos.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El stock del organizador del que proceden estas promos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O estoque do organizador de onde vêm essas promos.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lo stock dell'organizzatore da cui provengono queste promo.")
	return /** @type {LocalizedString} */ ("Whose stock these promos came from.")
});